export default __webpack_public_path__ + "static/media/lasik.a0877c42.svg";